import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import Icon, { Icons } from '../../components/Icon/Icon';
import PageHeader from '../../components/PageHeader';
import { t } from '../../lang';

import './StubPage.scss';

const defaultHeader = 'Empty page';
const defaultIcon = 'EMPTY_BH_PAGE';
const defaultText = 'There is nothing on this page';
const defaultIconSize = 140;
const defaultLabelIconSize = 48;

const StubPage = () => {
	const locationState = useLocation().state || {};

	const {
		header = defaultHeader,
		icon = defaultIcon,
		iconSize = defaultIconSize,
		labelIcon = null,
		labelIconSize = defaultLabelIconSize,
		text = defaultText,
	} = locationState;

	const iconNode =
		typeof icon === 'string' ? (
			<Icon
				className={classNames({ 'StubPage__have-label-icon': !locationState.icon && labelIcon })}
				type={Icons[icon]}
				width={iconSize}
				height={iconSize}
			/>
		) : (
			icon
		);

	const labelIconNode =
		typeof labelIcon === 'string' ? (
			<Icon type={Icons[labelIcon]} width={labelIconSize} height={labelIconSize} />
		) : (
			labelIcon
		);

	return (
		<div className='StubPage'>
			<PageHeader header={header} />
			<div className='StubPage__content'>
				<div className='StubPage__icon-box'>
					{iconNode}
					{labelIconNode && <div className='StubPage__label-icon'>{labelIconNode}</div>}
				</div>
				<div className='StubPage__text'>{t(text)}</div>
			</div>
		</div>
	);
};

export default StubPage;
